import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";

import type { NotesApi } from "@/Modules/Models/Api/ClinicalHistory";
import type { Notes } from "@/Modules/Models/Domain/ClinicalHistory";

import camel from "@/Utils/Camelize";
import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

const NotesTransformer: TransformerExtended<Notes, NotesApi> = {
  ...DefaultTransformerGenerator<Notes, NotesApi>(),

  toDomain(input: NotesApi) {
    return camel<NotesApi>(input) as Notes;
  },
};

export type NotesTransformerType = TransformerExtended<Notes, NotesApi>;

export default NotesTransformer;
